module services {
    export module master {
        export class termsOfDeliveryService implements interfaces.master.ITermsOfDeliveryService {
            static $inject = ["$resource", "ENV"];

            constructor(private $resource: ng.resource.IResourceService, private ENV: interfaces.applicationcore.serverConfig) {
            }

            //Gets list of all Terms Of Payment for a dropdown/autocomplete list
            getDropdownList(): ng.resource.IResourceClass<interfaces.applicationcore.IDropdownModel> {

                return this.$resource<interfaces.applicationcore.IDropdownModel>(this.ENV.DSP_URL + "TermsOfDelivery/GetDropdownList", {
                    ownerEntityId: '@ownerEntityId',
                    incoTermId: '@incoTermId',
                }, {
                        query: {
                            method: 'GET',
                            isArray: true
                        }
                    });
            }
        }
    }
    angular.module("app").service("termsOfDeliveryService", services.master.termsOfDeliveryService);
}